import { createContext } from "react";

export type PrintContextValue = {
  width: string;
  margin: string;
};

const PrintContext = createContext<PrintContextValue | null>(null);
export default PrintContext;
